import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const getDeviceID = async () => {
    const fp = await FingerprintJS.load()
    const result = await fp.get();   
    return result.visitorId
}

export default {getDeviceID}